<script setup lang="ts">
const props = defineProps<{
  size?: number
}>()
</script>

<template>
  <svg
    :width="props.size"
    :height="props.size"
    :viewBox="`0 0 56 56`"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="logo"
      d="M0 18C0 13.5817 3.58172 10 8 10C12.4183 10 16 13.5817 16 18L21.6569 12.3431C23.1571 10.8429 25.192 10 27.3137 10H28C32.4183 10 36 13.5817 36 18L41.6569 12.3431C43.1571 10.8429 45.192 10 47.3137 10H48C52.4183 10 56 13.5817 56 18V38C56 42.4183 52.4183 46 48 46C43.5817 46 40 42.4183 40 38V23.4242C40 21.4225 37.5799 20.4201 36.1645 21.8355C36.0592 21.9408 36 22.0837 36 22.2327V34C36 38.4183 32.4183 42 28 42C23.5817 42 20 38.4183 20 34V23.4242C20 21.4225 17.5799 20.4201 16.1645 21.8355C16.0592 21.9408 16 22.0837 16 22.2327V30C16 34.4183 12.4183 38 8 38C3.58172 38 0 34.4183 0 30V18Z"
    />
  </svg>
</template>
